var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!this.$route.query.iframeGame)?_c('BrandTest',{attrs:{"id":"divMarathonTestWrapper"}}):_vm._e(),(this.$route.query.iframeGame)?_c('div',[_c('iframe',{staticClass:"iframeGame",attrs:{"src":_vm.iframeLink}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }